import { useEffect } from 'react'

import { useFieldArray } from 'react-hook-form'

import { DigitalProductStoreBottomSheetRewardRequest } from '@/features/store/BottomSheet/RewardRequests/RewardRequest'
import { FormCheck } from '@/shared/ui/Form'


export const DigitalProductStoreWithdrawBottomSheetRewardRequestsField = ({
  refetchRewardRequests
}) => {
  const { fields: rewardRequests } = useFieldArray({
    name: 'reward_requests',
    keyName: '_id'
  })

  const handleWithdrawOrExpires = () => {
    setTimeout(() => {
      refetchRewardRequests()
    }, 300)
  }

  return (
    <div className="flex flex-col gap-8">
      {rewardRequests.map((rewardRequest, index) => (
        <div
          key={rewardRequest._id}
          className="flex items-center gap-3"
        >
          <div className="shrink-0 -mt-3">
            <FormCheck name={`reward_requests.${index}.selected`} solid />
          </div>
          <div className="flex-1">
            <DigitalProductStoreBottomSheetRewardRequest
              {...rewardRequest}
              onWithdraw={handleWithdrawOrExpires}
              onExpires={handleWithdrawOrExpires}
            />
          </div>
        </div>
      ))}
    </div>
  )
}
